import _extends from "@babel/runtime/helpers/extends";
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import Toggle from '../toggle';
import _Symbol from '../checkboxSymbol.svg.js';
import { dataHooks } from './constants';
import TooltipOnEllipsis from '../tooltipOnEllipsis';
import classNames from 'classnames';

var Checkbox = function Checkbox(props) {
  var label = props.label,
      labelAfterSymbol = props.labelAfterSymbol,
      children = props.children,
      translateIfNeeded = props.translateIfNeeded,
      getClassName = props.getClassName,
      type = props.type;
  return /*#__PURE__*/React.createElement(Toggle, _extends({}, props, {
    name: "checkbox",
    className: classNames(getClassName('control-checkbox'), props.vAlign === 'TOP' ? 'align-top' : 'align-center')
  }), label && !labelAfterSymbol ? /*#__PURE__*/React.createElement("span", {
    className: classNames('label', 'label-checkbox', type.toLowerCase()),
    key: "label"
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    dataHook: dataHooks.checkboxText,
    maxLines: props.maxLines
  }, translateIfNeeded(label))) : null, /*#__PURE__*/React.createElement("span", {
    className: "symbol symbol-checkbox"
  }, /*#__PURE__*/React.createElement(_Symbol, null)), label && labelAfterSymbol ? /*#__PURE__*/React.createElement("span", {
    className: classNames('label', 'label-checkbox', type.toLowerCase()),
    key: "label"
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    dataHook: dataHooks.checkboxText,
    maxLines: props.maxLines
  }, translateIfNeeded(label))) : null, children);
};

Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['T01', 'T02', 'T03', 'T04', 'T05', 'T06', 'T07', 'T08', 'T09', 'T10', 'T11', 'T12', 'T13', 'T14', 'T15', 'T16', 'T17', 'T18', 'T19', 'T20', 'T21']),
  labelAfterSymbol: PropTypes.bool,
  value: PropTypes.bool,
  maxLines: PropTypes.number,
  vAlign: PropTypes.oneOf(['TOP', 'CENTER'])
};
Checkbox.defaultProps = {
  type: '',
  labelAfterSymbol: false,
  value: false,
  maxLines: 1,
  vAlign: 'CENTER'
};
export default compose(Checkbox);